// extracted by mini-css-extract-plugin
export default {"CTA":"CTA_CTA__bNFr0","text":"CTA_text__fQONH"};